tinymce.PluginManager.add('placeholder', function(editor, url) {
	editor.ui.registry.addMenuButton('placeholder', {
		text: tinyMCE.translate('Placeholder'),
		fetch: function (callback) {
			var items = [];

			items.push(
				{
					type: 'menuitem',
					text: tinyMCE.translate('Company'),
					onAction: function () {
						editor.insertContent('[!company]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Email'),
					onAction: function () {
						editor.insertContent('[!email]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Zip'),
					onAction: function () {
						editor.insertContent('[!zip]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('City'),
					onAction: function () {
						editor.insertContent('[!city]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Contact name'),
					onAction: function () {
						editor.insertContent('[!contact_name]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Contact first name'),
					onAction: function () {
						editor.insertContent('[!contact_first_name]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Contact last name'),
					onAction: function () {
						editor.insertContent('[!contact_last_name]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Country'),
					onAction: function () {
						editor.insertContent('[!country]');
					},
				},
				{
					type: 'menuitem',
					text: tinyMCE.translate('Salutation'),
					onAction: function () {
						editor.insertContent('[!salutation]');
					},
				}
			);
			callback(items);
		}
	});

	return {
		getMetadata: function () {
			return  {
				name: "Example plugin",
				url: "http://exampleplugindocsurl.com"
			};
		}
	};
});